import { assertPrecondition, mfsError } from '../errors';

export type MfsValue = MfsSingleValue | MfsValue[] | null | undefined;

export type MfsSingleValue = number | string | boolean | Date | { [x: string]: MfsValue };

export const add = Symbol('add');
export const remove = Symbol('remove');

export type MfsDeltaValue = {
  [add]?: MfsValue[];
  [remove]?: MfsValue[];
};

export const MfsDeltaValue = {
  from: ({ addValues, removeValues }: { addValues?: MfsValue[]; removeValues?: MfsValue[] }): MfsDeltaValue => {
    assertPrecondition(!!addValues || !!removeValues, mfsError.invalidMfsDeltaValue);
    return { ...(addValues && { [add]: addValues }), ...(removeValues && { [remove]: removeValues }) };
  },
};
